<template lang="pug">
	div
		.btn-group.m-2
			button.btn(
				:class="(filtroTodosDias) ? 'btn-primary' : ''"
				@click="toggleTodosDias"
			) Todos
			button.btn(
				:class="(filtroEntreSemana) ? 'btn-primary' : ''"
				@click="toggleEntreSemana"
			) Entre semana
			button.btn(
				:class="(filtroSyV) ? 'btn-primary' : ''"
				@click="toggleFinde"
			) Fin de semana
		br
		.btn-group.m-2
			button.btn(
				:class="(misDias.indexOf(i) >= 0) ? 'btn-primary' : ''",
				@click="toggleDiaFiltro(i)",
				v-for="(d, i) in Array(7)"
			) {{diasSTR[i]}}
</template>

<script>
export default {
	props: ['dias'],
	data () {
		return {
			misDias: [],
			diasSTR: ['L', 'M', 'X', 'J', 'V', 'S', 'D']
		}
	},
	created () {
		this.misDias = [].concat(this.dias)
	},
	watch: {
		dias: function (newValue) {
			this.misDias = [].concat(newValue)
			this.misDias.sort()
		}
	},
	computed: {
		filtroTodosDias () {
			return (this.misDias.length === 7)
		},
		filtroEntreSemana () {
			const dias = [0, 1, 2, 3, 4]

			for (let i = 0; i < dias.length; i++) {
				if (this.misDias.indexOf(dias[i]) < 0) {
					return false
				}
			}
			return true
		},
		filtroSyV () {
			return (this.misDias.indexOf(5) >= 0 && this.misDias.indexOf(6) >= 0)
		}
	},
	methods: {
		toggleTodosDias () {
			if (this.misDias.length === 0) {
				for (let i = 0; i < 7; i++) {
					this.misDias.push(i)
				}
			} else {
				this.misDias = []
			}

			this.update()
		},
		toggleEntreSemana () {
			const dias = [0, 1, 2, 3, 4]
			let encontrado = false

			for (let i = 0; i < dias.length; i++) {
				if (this.misDias.indexOf(dias[i]) >= 0) {
					encontrado = true
				}
			}

			if (encontrado) {
				for (let i = 0; i < dias.length; i++) {
					const pos = this.misDias.indexOf(dias[i])
					if (pos >= 0) {
						this.misDias.splice(pos, 1)
					}
				}
			} else {
				for (let i = 0; i < dias.length; i++) {
					const pos = this.misDias.indexOf(dias[i])
					if (pos < 0) {
						this.misDias.push(dias[i])
					}
				}
			}
			this.update()
		},
		toggleFinde () {
			if (this.misDias.indexOf(5) >= 0 || this.misDias.indexOf(6) >= 0) {
				const s = this.misDias.indexOf(5)
				if (s >= 0) {
					this.misDias.splice(s, 1)
				}
				const d = this.misDias.indexOf(6)
				if (d >= 0) {
					this.misDias.splice(d, 1)
				}
			} else {
				if (this.misDias.indexOf(5) < 0) {
					this.misDias.push(5)
				}
				if (this.misDias.indexOf(6) < 0) {
					this.misDias.push(6)
				}
			}
			this.update()
		},
		toggleDiaFiltro (dia) {
			const i = this.misDias.indexOf(dia)
			if (i >= 0) {
				this.misDias.splice(i, 1)
			} else {
				this.misDias.push(dia)
			}
			this.update()
		},
		update () {
			this.misDias.sort()
			this.$emit('update:dias', this.misDias)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/gestion-emisoras/vue/componentes/utilidades/select-dias.vue